import { SCROLL_TO_QUERY_PARAM } from "../helpers/removeScrollToQuery/constants";

const isPersisted = event => event.persisted;

const MAX_SCROLL_RESTORE_ATTEMPTS = 10;
const FRAME_FALLBACK_DELAY = 16;

export const getScrollToElementId = (search = window.location.search) =>
  new URLSearchParams(search).get(SCROLL_TO_QUERY_PARAM);

const getScrollRestoreScheduler = () => {
  if (typeof window.requestAnimationFrame === "function") {
    return {
      schedule: callback => window.requestAnimationFrame(callback),
      cancel: callbackId => window.cancelAnimationFrame(callbackId)
    };
  }

  return {
    schedule: callback => window.setTimeout(callback, FRAME_FALLBACK_DELAY),
    cancel: callbackId => window.clearTimeout(callbackId)
  };
};

const scrollToElement = element => {
  if (!element) {
    return false;
  }

  element.scrollIntoView();

  return true;
};

const anchorToProduct = (scrollToElementId = getScrollToElementId()) => {
  if (!("onpagehide" in window)) {
    return;
  }

  const { schedule, cancel } = getScrollRestoreScheduler();
  const canManageNativeScrollRestoration =
    !!scrollToElementId && "scrollRestoration" in window.history;
  const originalScrollRestoration = canManageNativeScrollRestoration
    ? window.history.scrollRestoration
    : null;
  let restoreJobId = null;
  let hasRestoredScrollPosition = false;

  if (canManageNativeScrollRestoration) {
    window.history.scrollRestoration = "manual";
  }

  const clearRestoreJob = () => {
    if (restoreJobId === null) {
      return;
    }

    cancel(restoreJobId);
    restoreJobId = null;
  };

  const resetNativeScrollRestoration = () => {
    if (canManageNativeScrollRestoration) {
      window.history.scrollRestoration = originalScrollRestoration;
    }
  };

  const scheduleScrollRestore = (attempt = 0) => {
    if (
      !scrollToElementId ||
      restoreJobId !== null ||
      hasRestoredScrollPosition
    ) {
      return;
    }

    restoreJobId = schedule(() => {
      restoreJobId = null;

      const element = document.getElementById(scrollToElementId);

      if (scrollToElement(element)) {
        hasRestoredScrollPosition = true;
        resetNativeScrollRestoration();

        return;
      }

      if (attempt >= MAX_SCROLL_RESTORE_ATTEMPTS) {
        resetNativeScrollRestoration();

        return;
      }

      scheduleScrollRestore(attempt + 1);
    });
  };

  window.addEventListener("pageshow", event => {
    if (isPersisted(event)) {
      return;
    }

    scheduleScrollRestore();
  });

  window.addEventListener("pagehide", event => {
    clearRestoreJob();
    resetNativeScrollRestoration();

    if (isPersisted(event)) {
      return;
    }

    window.scrollTo(0, 0);
  });
};

export default anchorToProduct;
